import { Controller } from 'stimulus';

class Recommend extends Controller {
  addFriend() {
    const $clone = $(this.templateTarget).clone();

    $clone.find('input').each((i, input) => {
      input.value = '';
    });

    $clone.appendTo($(this.outputTarget));

    if ($('.recommendations-form__fieldset').length >= 10) {
      $('.recommendations-form__add').toggle();
    }

    this.reindexFields();
  }

  removeFriend(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.parents('.recommendations-form__fieldset');

    $parent.remove();

    this.reindexFields();
  }

  reindexFields() {
    const attributes = ['for', 'id', 'name'];

    this.templateTargets.forEach((templateElement, index) => {
      if (index === 0) {
        return;
      }

      $(templateElement).find('label, input').toArray().forEach((element) => {
        attributes.forEach((attr) => {
          const attribute = element.getAttribute(attr);

          if (attribute) {
            const newIndex = attribute.replace(/^friends\[\w+]\[/, `friends[${index}][`);
            element.setAttribute(attr, newIndex);
          }
        });
      });
    });
  }
}

Recommend.targets = [
  'template',
  'add',
  'remove',
  'output',
];

export default Recommend;
